import { Observable } from 'rxjs';
import { SystemPermission } from '../../../model/src/lib/system-permission.model';
import { UserProfile } from '../../../model/src/lib/user-profile.model';
import { UserProfileService } from './user-profile.service';

export abstract class AuthenticationBaseService {
  constructor(protected userProfileService: UserProfileService) {}

  /**
   * @description 登入使用者基本資料 Observable 物件
   */
  get currentUser(): Observable<UserProfile | null> {
    return this.userProfileService.currentUserSubject.asObservable();
  }

  /**
   * @description 登入使用者基本資料
   */
  get currentUserValue(): UserProfile | null {
    return this.userProfileService.currentUserSubject.value;
  }

  /**
   * @description 登入使用者授權資料 Observable 物件
   */
  get currentSystemPermissions(): Observable<SystemPermission[]> {
    return this.userProfileService.currentSystemPermissionsSubject.asObservable();
  }

  /**
   * @description 登入使用者授權資料
   */
  get currentSystemPermissionsValue(): SystemPermission[] {
    return this.userProfileService.currentSystemPermissionsSubject.value;
  }

  /**
   * @description 檢查使用者是否有指定權限
   * @param systemCode system code
   * @param functionCode function code
   * @param privilegeCode privilege code
   * @returns 是否有權限
   */
  hasPermission(
    systemCode: string,
    functionCode: string,
    privilegeCode: string
  ): boolean {
    if (
      systemCode &&
      functionCode &&
      privilegeCode &&
      this.currentSystemPermissionsValue &&
      this.currentSystemPermissionsValue.length > 0
    ) {
      return this.currentSystemPermissionsValue.some((p) => {
        return (
          p.systemCode === systemCode &&
          p.functionCode === functionCode &&
          p.privilegeCode === privilegeCode
        );
      });
    }

    return false;
  }

  /**
   * @description 是否已登入
   */
  abstract get isAuthenticated(): boolean;

  /**
   * @description 登出
   */
  abstract logout(): void;
}
